import { httpAuth } from 'config/apiClient'
import endpoints from 'constants/endpoints'

export const fetchFileCommentCount = async (oid: string, parentCid: string): Promise<number | undefined> => {
  const { data } = await httpAuth.get(endpoints.commentsCounter, { params: { oid, parent_cid: parentCid } })
  return data?.[oid]?.num_of_comments ?? data?.num_of_comments
}
